module.exports = __webpack_public_path__ + "img/Airbnb-Hybrid-Mobility-0-Headphones.e12c683d.png";